import { useState } from "react";
import useCartStore from "../../utils/cartStore";

const COLORS = ["Noir", "Lait", "Blanc", "Gold", "Ruby"];

const MENDIANT_IMAGES = {
  Noir: "/images/mendiants/mendiants_noir.jpg",
  Lait: "/images/mendiants/mendiants_aulait.jpg",
  Blanc: "/images/mendiants/mendiants_blanc.jpg",
  Gold: "/images/mendiants/mendiants_gold.jpg",
  Ruby: "/images/mendiants/mendiants_ruby.jpg",
};

const MendiantsBox = ({ type }) => {
  const addToCart = useCartStore(state => state.addToCart);

  const [size, setSize] = useState(8);

  const [composition, setComposition] = useState({
    Noir: 0,
    Lait: 0,
    Blanc: 0,
    Gold: 0,
    Ruby: 0
  });

  const price = size === 8 ? 9 : 16;

  const totalPieces = Object.values(composition).reduce(
    (a, b) => a + b,
    0
  );

  const handleChange = (color, value) => {
    const newComposition = {
      ...composition,
      [color]: Number(value)
    };

    const newTotal = Object.values(newComposition).reduce(
      (a, b) => a + b,
      0
    );

    if (newTotal <= size) {
      setComposition(newComposition);
    }
  };

  const handleAdd = (color = null) => {
    if (type === "standard") {
      addToCart(
        {
          id: `mendiants-${color}-${size}`,
          name: `Boîte ${size} Mendiants ${color}`,
          price: price,
          image: MENDIANT_IMAGES[color],
          category: "Mendiants"
        },
        1
      );
    } else {
      if (totalPieces !== size) {
        alert(`Vous devez choisir exactement ${size} pièces`);
        return;
      }

      const description = COLORS
        .map(c => composition[c] ? `${composition[c]} ${c}` : null)
        .filter(Boolean)
        .join(", ");

      addToCart(
        {
          id: `mendiants-personnalise-${Date.now()}`,
          name: `Boîte personnalisée ${size} mendiants`,
          price: price,
          image: "/images/mendiants/mendiants_standars.jpg",
          category: "Mendiants",
          description: description
        },
        1
      );
    }
  };

  return (
    <section className="mb-20 p-8 bg-gray-50 rounded-2xl">

      <h2 className="text-2xl font-semibold mb-6">
        {type === "standard"
          ? "Boîtes Classiques"
          : "Personnaliser ma boîte"}
      </h2>

      <div className="mb-6">
        <label className="mr-4 font-medium">
          Taille de la boîte :
        </label>

        <select
          value={size}
          onChange={(e) => setSize(Number(e.target.value))}
          className="border rounded-lg px-3 py-2"
        >
          <option value={8}>8 pièces (9€)</option>
          <option value={16}>16 pièces (16€)</option>
        </select>
      </div>

      {/* BOITES CLASSIQUES */}
      {type === "standard" && (
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">

          {COLORS.map(color => (
            <div
              key={color}
              className="bg-white p-6 rounded-xl shadow text-center"
            >
              <img
                src={MENDIANT_IMAGES[color]}
                alt={color}
                className="w-full h-40 object-cover rounded-lg mb-4"
              />

              <h3 className="font-semibold mb-3">{color}</h3>

              <p className="text-gray-500 mb-4">
                {size} mendiants {color}
              </p>

              <p className="font-bold mb-4">{price} €</p>

              <button
                onClick={() => handleAdd(color)}
                className="btn-primary w-full"
              >
                Ajouter au panier
              </button>
            </div>
          ))}
        </div>
      )}

      {/* PERSONNALISER */}
      {type === "personalise" && (
        <div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 mb-6">

            {COLORS.map(color => (
              <div key={color}>

                <img
                  src={MENDIANT_IMAGES[color]}
                  alt={color}
                  className="w-full h-32 object-cover rounded-lg mb-2"
                />

                <label className="block mb-2 font-medium">
                  {color}
                </label>

                <input
                  type="number"
                  min="0"
                  max={size}
                  value={composition[color]}
                  onChange={(e) =>
                    handleChange(color, e.target.value)
                  }
                  className="w-full border rounded-lg px-3 py-2"
                />
              </div>
            ))}

          </div>

          <p className="mb-4 text-gray-600">
            {totalPieces} / {size} pièces sélectionnées
          </p>

          <button
            onClick={() => handleAdd()}
            className="btn-primary"
          >
            Ajouter ma boîte au panier ({price} €)
          </button>

        </div>
      )}

    </section>
  );
};

export default MendiantsBox;